import React from "react";
import { arrayOf, func, shape, string } from "prop-types";
import { cn } from "@/components/utils";
import withValidation from "@/hocs/withValidation";

import {
  Select as BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { Hint } from "@/components/ui/input";

let Select = ({
  id,
  value,
  valueRenderer,
  label,
  hint,
  className,
  onChange,
  options,
  optionRenderer,
  disabled,
  isLoading,
  placeholder,
  validation,
}) => {
  return (
    <div>
      {label && (
        <label className="mb-1 font-semibold" htmlFor={id}>
          {label}
        </label>
      )}
      {hint && <Hint>{hint}</Hint>}
      <BaseSelect
        id={id}
        disabled={disabled || isLoading}
        value={value}
        onValueChange={onChange}
      >
        <SelectTrigger
          isLoading={isLoading}
          className={cn(className, validation.className)}
        >
          <SelectValue placeholder={placeholder}>
            {valueRenderer?.(value)}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options?.map((option) => (
            <SelectItem
              key={`${option.label}__${option.value}`}
              value={option.value}
            >
              {optionRenderer(option)}
            </SelectItem>
          ))}
        </SelectContent>
      </BaseSelect>
      {validation.elements}
    </div>
  );
};

Select.propTypes = {
  id: string,
  value: string,
  label: string,
  onChange: func,
  options: arrayOf(shape({ value: string, label: string })),
  optionRenderer: func,
};

Select.defaultProps = {
  options: [],
  optionRenderer: ({ label }) => label,
};

Select = withValidation()(Select);

export default Select;
